import webImg from "./images/web.png";
import dsImg from "./images/ds.png";
import mlImg from "./images/ml.png";
import uiImg from "./images/ui.png";
import ccImg from "./images/cc.png";
import csImg from "./images/cs.png";

export default function Categories() {
  const categories = [
    { title: "Web Development", image: webImg },
    { title: "Data Science", image: dsImg },
    { title: "Machine Learning", image: mlImg },
    { title: "UI/UX Design", image: uiImg },
    { title: "Cloud Computing", image: ccImg },
    { title: "Cyber Security", image: csImg },
  ];

  return (
    <section className="py-16 px-8 bg-gray-50">
      <h2 className="text-3xl font-bold text-gray-800 mb-10 text-center">
        Top Categories
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
        {categories.map((cat, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-xl p-4 text-center hover:shadow-xl transition cursor-pointer"
          >
            <img
              src={cat.image}
              alt={cat.title}
              className="w-16 h-16 mx-auto mb-4"
            />
            <h3 className="font-semibold text-gray-700">{cat.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}
